import './footer.styles.css'

const Footer = () =>{
    return(
        <footer className="footer">
            <span>Feito com amor por Sâmara Nascimento - 2021</span>
        </footer>
    )
}


export default Footer
